<template>
  <tr :ref="onMeasure" :data-index="index">
    <th colspan="100%" :class="[`p-0`, index !== 0 && `pt-4`]">
      <div
        :class="[
          `border-border px-4 pt-4 text-left text-xs font-bold uppercase tracking-wider text-muted-foreground`,
          index !== 0 && `border-t`,
          row.groupingValue && `pb-2.5`,
        ]"
      >
        {{ row.groupingValue }}
      </div>
    </th>
  </tr>
</template>

<script setup lang="ts" generic="Model extends GenericModel">
import type { Row } from "@tanstack/vue-table";

import type { GenericModel } from "@/types/model";

const props = defineProps<{
  row: Row<Model>;
  index: number;
  onMeasure: (node: any) => void;
}>();

const onMeasure = props.onMeasure;
</script>
